
export default class AudioElement {
    constructor(_root) {
        this._root = _root;
        this._audio = this._root.querySelector('audio');
        this._trigger = this._root.querySelector('.audio-element-action');
        this._labels = this._getLabels();
        this._durationElement = this._root.querySelector(
            '.audio-element-duration'
        );
        this._setupEventListeners();
    }

    _setupEventListeners() {
        this._trigger.addEventListener(
            'click',
            this._tooglePlayPause.bind(this)
        );
        this._audio.addEventListener('loadedmetadata', this._renderDuration());
        this._audio.addEventListener('ended', event => {
            this._reset();
        });
        this._audio.addEventListener('timeupdate', event => {
            this._renderDuration();
        });

    }

    _getLabels() {
        const labels = this._trigger.getAttribute('data-labels');
        return labels !== ''  ? JSON.parse(labels) : {};
    }

    _tooglePlayPause() {
        const isPaused = this._audio.paused;
        if (isPaused) {
            this._play();
        } else {
            this._pause();
        }
    }

    _reset() {
        this._pause();
        this._renderDuration(true);
    }

    _pause() {
        this._trigger.classList.replace(
            'audio-element-pause',
            'audio-element-play'
        );
        this._audio.pause();
        this._trigger.setAttribute('title', this._labels.play);
    }

    _play() {
        this._trigger.classList.replace(
            'audio-element-play',
            'audio-element-pause'
        );
        this._audio.play();
        this._trigger.setAttribute('title', this._labels.pause);
    }

    _renderDuration(renderPureDuration) {
        let mediaDuration = this._audio.duration;
        if (isNaN(this._audio.duration)) {
            mediaDuration = this._durationElement.dataset.duration;
        }
        const duration =
            renderPureDuration === true
                ? mediaDuration
                : mediaDuration - this._audio.currentTime;

        const minutes = parseInt(duration / 60, 10);
        let seconds = parseInt(duration % 60, 10);
        if (!isNaN(minutes) && !isNaN(seconds)) {
            seconds = seconds >= 10 ? seconds : '0' + seconds;
            const newTime = `${minutes}:${seconds}`;
            const durationString = this._durationElement.innerHTML;
            this._durationElement.innerHTML = durationString.replace(
                /([0-5]?)[0-9]:(?:[012345]\d)/gi,
                newTime
            );
        }
    }
}
